/*
  Barra de descuento por volumen (Empresas, b2b.myscrubs.cl) - 03-nov-2026.
  Los tramos los aplican 4 descuentos automaticos de Shopify ("Descuento empresas 5%/10%/15%/20%")
  sobre la coleccion b2b-precio-full. Este script solo MUESTRA el tramo y cuanto falta:
  no calcula ni cambia precios.

  Monto que cuenta para el tramo = suma de las lineas a precio full. Toda linea a precio
  full lleva al menos el 5%, asi que se reconoce por tener una asignacion de descuento
  cuyo titulo empieza con "Descuento empresas". Ofertas y bordado no cuentan (igual que Shopify).
  Si cambian los montos de los descuentos, cambiar TRAMOS aqui.
*/
(function () {
  var TRAMOS = [ // montos en pesos, con IVA (igual que el minimo de cada descuento)
    { desde: 0, pct: 5 },
    { desde: 600000, pct: 10 },
    { desde: 1200000, pct: 15 },
    { desde: 2400000, pct: 20 }
  ];
  var ultimoCarro = null;

  var css = '.b2b-tramos{margin:0 0 1.2rem;padding:1rem 1.2rem;border-radius:8px;background:rgba(14,124,134,.08);font-size:1.3rem;line-height:1.4;text-align:left}' +
    '.b2b-tramos strong{font-weight:700}' +
    '.b2b-tramos__barra{height:6px;border-radius:3px;background:rgba(0,0,0,.1);margin:.7rem 0 .5rem;overflow:hidden}' +
    '.b2b-tramos__barra span{display:block;height:100%;background:#0e7c86;border-radius:3px}' +
    '.b2b-tramos__nota{font-size:1.15rem;opacity:.75;margin:0}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function pesos(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function montoFull(cart) {
    var total = 0;
    (cart.items || []).forEach(function (it) {
      var full = (it.line_level_discount_allocations || []).some(function (a) {
        return a.discount_application && /^Descuento empresas/i.test(a.discount_application.title || '');
      });
      if (full) total += (it.original_line_price || 0) / 100;
    });
    return total;
  }

  function html(cart) {
    if (!cart || !cart.item_count) return '';
    var m = montoFull(cart);
    if (m <= 0) {
      return '<p class="b2b-tramos__nota">Los productos en oferta y los cargos de bordado no llevan descuento por volumen.</p>';
    }
    var actual = TRAMOS[0], sig = null;
    for (var i = 0; i < TRAMOS.length; i++) {
      if (m >= TRAMOS[i].desde) { actual = TRAMOS[i]; sig = TRAMOS[i + 1] || null; }
    }
    var txt = 'Descuento por volumen: <strong>' + actual.pct + '%</strong> en productos a precio full.';
    var barra = '';
    if (sig) {
      var falta = sig.desde - m;
      var avance = Math.max(4, Math.min(100, ((m - actual.desde) / (sig.desde - actual.desde)) * 100));
      txt += '<br>Te faltan <strong>' + pesos(falta) + '</strong> para llegar al <strong>' + sig.pct + '%</strong>.';
      barra = '<div class="b2b-tramos__barra" aria-hidden="true"><span style="width:' + avance.toFixed(0) + '%"></span></div>';
    } else {
      txt += '<br>Tienes el descuento máximo.';
    }
    return '<div>' + txt + '</div>' + barra +
      '<p class="b2b-tramos__nota">5% en todo pedido · 10% desde $600.000 · 15% desde $1.200.000 · 20% desde $2.400.000, en productos a precio full. Ofertas y bordado no llevan descuento.</p>';
  }

  function pintar() {
    var contenido = html(ultimoCarro);
    var destinos = document.querySelectorAll('.cart-drawer__footer, #main-cart-footer .cart__blocks');
    Array.prototype.forEach.call(destinos, function (d) {
      var el = d.querySelector(':scope > .b2b-tramos');
      if (!contenido) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement('div'); el.className = 'b2b-tramos'; el.setAttribute('role', 'status'); d.insertBefore(el, d.firstChild); }
      if (el.innerHTML !== contenido) el.innerHTML = contenido;
    });
  }

  var pidiendo = false;
  function refrescar() {
    if (pidiendo) return;
    pidiendo = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { ultimoCarro = c; pintar(); })
      .catch(function () {})
      .then(function () { pidiendo = false; });
  }

  // El tema vuelve a dibujar el carro en cada cambio: reponer la barra si desaparece.
  var obs = new MutationObserver(function () {
    if (ultimoCarro && document.querySelector('.cart-drawer__footer:not(:has(> .b2b-tramos)), #main-cart-footer .cart__blocks:not(:has(> .b2b-tramos))')) pintar();
  });

  function iniciar() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refrescar, 150); });
    }
    obs.observe(document.body, { childList: true, subtree: true });
    refrescar();
  }
  // Este script se carga antes que pubsub.js: esperar a DOMContentLoaded (corre despues de todos los defer).
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
